import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BackendApi } from '../../services/backend-api';
import { Area } from '../../models/area';
import { AsyncPipe } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { map, Observable, startWith } from 'rxjs';
import { Package, PackageAreaCreate } from '../../models/package';

@Component({
  selector: 'app-create-package-area-dialog',
  imports: [MatDialogModule, MatInputModule, MatButtonModule, MatFormFieldModule, ReactiveFormsModule, MatSelectModule, MatAutocompleteModule, AsyncPipe],
  templateUrl: './create-package-area-dialog.html',
  styleUrl: './create-package-area-dialog.css',
})
export class CreatePackageAreaDialog {
  constructor(
    private readonly backendApi: BackendApi,
    private dialogRef: MatDialogRef<CreatePackageAreaDialog>,
    @Inject(MAT_DIALOG_DATA) public thePackage: Package
  ) { }

  private _snackBar = inject(MatSnackBar);
  private _formBuilder = inject(FormBuilder);

  public areas!: Area[];
  public filteredAreas?: Observable<Area[]>;

  packageAreaForm = this._formBuilder.group({
    area: ['', Validators.required]
  });

  private _filterAreas(value: string) {
    return this.areas?.filter(area => this._normalize(area.country.name_fr).includes(this._normalize(value)));
  }

  private _normalize(str: string): string {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }

  ngOnInit() {
    this.filteredAreas = this.packageAreaForm.get('area')?.valueChanges.pipe(
      startWith(''),
      map(value => this._filterAreas(value || ''))
    )

    this.backendApi.getAreas().subscribe({
      next: (areas) => {
        this.areas = areas;
      },
      error: () => {
        this._snackBar.open("Erreur rencontrée lors de la recuperation des areas.");
      }
    });
  }

  submit() {
    const packageArea: PackageAreaCreate = this.packageAreaForm.value as PackageAreaCreate;

    this.backendApi.createPackageArea(this.thePackage.uuid, packageArea).subscribe({
      next: (response) => {
        this._snackBar.open("Entrée ajoutée.");
        this.dialogRef.close(response);
      },
      error: () => {
        this._snackBar.open("Erreur rencontrée.");
      }
    })
  }
}
